import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomTab } from "../../atomicComponents";
import BackButton from "../../clientComponents/BackButton/BackButton";
import { APILimit, areaListTableHeader, AUTH_CODE, driverListTableHeader, path_Operation, reset_pin_timer } from "../../constants/constVariables";
import { downloadData } from "../../constants/Utils";
import { areaListAPI, bulkDriverDeleteAPI, driverListApi, resetDriverPinApi } from "../../utils/apiServices";
import DataNotFound from "../DataNotFound";
import { ErrorModal, SuccessModal, WarningModal } from "../FormComponents";
import FormModal from "../FormComponents/FormModal";
import Loader from "../Loader";
import { dateFormat, getPlantValue, postUsageAnalyticsCall } from "../../constants/Utils";
import Table from "../Table/Table";
import clsx from 'clsx';
import { useAuthorizationContext } from "../../providers/AuthorizationHandler/AuthorizationHandler";

const DriverMaster = () => {

    const { user } = useAuthorizationContext();
    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const [isWarningModalOpen, setWarningModalIsOpen] = useState(false);
    const [isErrorModalOpen, setErrorModalIsOpen] = useState(false);
    const [deleteData, setDeleteData] = useState([]);
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [totalError, setTotalError] = useState(false);
    const [selectCount, setSelectCount] = useState(0);
    const [checkedState, setCheckedState] = useState([]);
    const [checkedStateAll, setCheckedStateAll] = useState(false);
    const [totalData, setTotalData] = useState("00");
    const [hasNext, sethasNext] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [offset, setOffset] = useState(0);
    const date = new Date()
    const [driverList, setDriverDataList] = useState([{}]);
    const [allSelectedRows, setAllSelectedRows] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isBulkDeletedFlag, setIsBulktIsDeletedFlag] = useState(false);
    const [title, setTitle] = useState('');
    const [timer, setTimer] = useState([]);
    const [pageLeaveTime, setPageLeaveTime] = useState();

    const timer_minutes = useRef("");
    const timer_seconds = useRef("");

    // const response = {
    //     "data": {
    //         "status_code": 200,
    //         "message": "Area retrieve successfully.",
    //         "has_next": false,
    //         "count": 36,
    //         "total_count": 36,
    //         "data": [
    //             {
    //                 "driver_id": "6b0f4015-0a38-4efe-a4d6-370c583d01f3",
    //                 "first_name": "Rahul",
    //                 "last_name": "Sharma",
    //                 "contractor_name":"Swaraj Pvt. Ltd.",
    //                 "contractor_phone_no":"1234567890",
    //                 "driver_phone_no":"1234567890",
    //                 "updated_at":date,
    //                 "updated_by":"Rohit Sharma",
    //                 "reset_pin":""

    //             },
    //             {
    //                 "driver_id": "e46571e8-c805-4a84-964a-5e73135d237f",
    //                 "first_name": "Rahul",
    //                 "last_name": "Sharm",
    //                 "contractor_name":"Swaraj Pvt. Ltd.",
    //                 "contractor_phone_no":"1234567890",
    //                 "driver_phone_no":"1234567890",
    //                 "updated_at":date,
    //                 "updated_by":"Rohit Sharma",
    //                 "reset_pin":""
    //             },
    //             {
    //                 "driver_id": "5e02d63c-390d-47dd-b2f4-271d84343955",
    //                 "first_name": "Rahul",
    //                 "last_name": "Sharma",
    //                 "contractor_name":"Swaraj Pvt. Ltd.",
    //                 "contractor_phone_no":"1234567890",
    //                 "driver_phone_no":"1234567890",
    //                 "updated_at":date,
    //                 "updated_by":"Rohit Sharma",
    //                 "reset_pin":""
    //             },
    //             {
    //                 "driver_id": "acf610a3-f5e4-4c34-ad3d-d4c3e526fa22",
    //                 "first_name": "Rahul",
    //                 "last_name": "Sharma",
    //                 "contractor_name":"Swaraj Pvt. Ltd.",
    //                 "contractor_phone_no":"1234567890",
    //                 "driver_phone_no":"1234567890",
    //                 "updated_at":date,
    //                 "updated_by":"Rohit Sharma",
    //                 "reset_pin":""
    //             },
    //             {
    //                 "driver_id": "2ce8dbce-a6a1-45b6-97aa-6c231ef02fdb",
    //                 "first_name": "Rahul",
    //                 "last_name": "Sharma",
    //                 "contractor_name":"Swaraj Pvt. Ltd.",
    //                 "contractor_phone_no":"1234567890",
    //                 "driver_phone_no":"1234567890",
    //                 "updated_at":date,
    //                 "updated_by":"Rohit Sharma",
    //                 "reset_pin":""
    //             }
    //         ]
    //     },
    //     "status": 200,
    //     "statusText": "",
    //     "headers": {
    //         "content-length": "30728",
    //         "content-type": "application/json"
    //     },
    //     "config": {
    //         "transitional": {
    //             "silentJSONParsing": true,
    //             "forcedJSONParsing": true,
    //             "clarifyTimeoutError": false
    //         },
    //         "transformRequest": [
    //             null
    //         ],
    //         "transformResponse": [
    //             null
    //         ],
    //         "timeout": 0,
    //         "xsrfCookieName": "XSRF-TOKEN",
    //         "xsrfHeaderName": "X-XSRF-TOKEN",
    //         "maxContentLength": -1,
    //         "maxBodyLength": -1,
    //         "env": {
    //             "FormData": null
    //         },
    //         "headers": {
    //             "Accept": "application/json, text/plain, */*",
    //             "Authorization": "Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJDWGhMRzdjRjJiVVdsSFdURVBNVmYxM2hQSl9qaVdndG5fdDJ0NHhCa19ZIn0.eyJleHAiOjE2NzcwNDE1NzcsImlhdCI6MTY3NzA0MTA5NywiYXV0aF90aW1lIjoxNjc3MDQwMTg1LCJqdGkiOiI2MWE5YjA5OC1kMzUxLTQwNzUtOTRhMy1hZTU4MTdlNDRkYTYiLCJpc3MiOiJodHRwczovL3FhLnNzby50YXRhbW90b3JzLmNvbS9hdXRoL3JlYWxtcy91ZHlvZyIsImF1ZCI6ImFjY291bnQiLCJzdWIiOiJjMjkwMmYwZC1jOGQ2LTQ2NjEtYTBlNC0yNjIwMmI1ZGZjYTMiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJhdmFudGdhcmRlLXRyYWNrLXlvdXItdmVoaWNsZSIsIm5vbmNlIjoiYTEzNTM1NDctNDIxYy00MzIzLThkYjctNTk1OTczNzBkMGUxIiwic2Vzc2lvbl9zdGF0ZSI6IjA1MDRjZWU0LWM1MjUtNDgyYS1hYTBiLTU1NWZlNDgzOTdlNyIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwczovL2hvbWUuYXZhbnRnYXJkZS1kZXYudGF0YW1vdG9ycy5jb20iLCJodHRwczovL2hvbWUuYXZhbnRnYXJkZS1wcmUtcHJvZC50YXRhbW90b3JzLmNvbSIsImh0dHA6Ly9sb2NhbGhvc3Q6MzAwMCIsImh0dHBzOi8vdHl2LnNhZGhhbi1kZXYudGF0YW1vdG9ycy5jb20iLCJodHRwczovL3R5di5zYWRoYW4tcHJlLXByb2QudGF0YW1vdG9ycy5jb20iXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIm9mZmxpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iXX0sInJlc291cmNlX2FjY2VzcyI6eyJhY2NvdW50Ijp7InJvbGVzIjpbIm1hbmFnZS1hY2NvdW50IiwibWFuYWdlLWFjY291bnQtbGlua3MiLCJ2aWV3LXByb2ZpbGUiXX19LCJzY29wZSI6Im9wZW5pZCBlbWFpbCBwcm9maWxlIGF2YW50Z2FyZGUtdHJhY2steW91ci12ZWhpY2xlLWNzIiwic2lkIjoiMDUwNGNlZTQtYzUyNS00ODJhLWFhMGItNTU1ZmU0ODM5N2U3IiwidHJhY2tfeW91cl92ZWhpY2xlX2Z1bmN0aW9ucyI6WyJhZG1pbiIsIk1hbnVmYWN0dXJpbmciXSwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJwbGFudHMiOlsiMTAwMSIsIjIwMDEiXSwibmFtZSI6IlZpamF5IFZlbnUiLCJ1c2VyLWdyb3VwcyI6WyIvQXZhbnRnYXJkZS1Ib21lL1NhYWRoYW4vVHJhY2stWW91ci1WZWhpY2xlIl0sInByZWZlcnJlZF91c2VybmFtZSI6InZpamF5di5zcyIsImdpdmVuX25hbWUiOiJWaWpheSIsImZhbWlseV9uYW1lIjoiVmVudSIsImVtYWlsIjoidmlqYXl2LnNzQHRhdGFtb3RvcnMuY29tIn0.hI2_kK2EFVIQDbGfgY-3aVusMPMT0dUAiWYNP_Aw-5rUcu1gXvX9Hh5VKBkmy8f3otcRqJ-Gw5jiXPNPCHSiHc31OEdtvf4IzMsjnAWR87qt7YBLqqW8YrRmbF5joFDecsLBUj-gdR4iSF84inecYH6jIsJb_sETx1qwWHnyTyPctalbeddBgZWgs0VsMZSl4OyVW4zVYNXfwe-jU596T-hL1k31vBJkb-7VGXqSLqo-nEihe8Mj-ko3ChPyGVJlw1LbIzdfAUXEkjrF4n_s9EIui3QzbZKnSesKkAOECiTPtoiR6oPpx6qjJYOaE9y8v0hb2AEh0yiuWyPTYKNy5Q"
    //         },
    //         "method": "get",
    //         "url": "https://c931-114-143-107-6.in.ngrok.io/api/area-list?plantid=bbbb1fa9-03b8-4154-aaf5-b89f4c05763c&search=all&limit=100000&offset=0"
    //     },
    //     "request": {}
    // }
    const navigate = useNavigate();
    const createDriverRedirect = (() => {
        navigate("/driver-master/add-new-driver");
    })
    const browserBack = () => {
        navigate("/");
    }
    const toggleWarningModal = (data, e) => {
        setDeleteData(data);
        setWarningModalIsOpen(!isWarningModalOpen);
    };
    const handleEdit = (dataa) => {
        dataa[0].reset_pin = '';
        navigate("/driver-master/edit-driver", { state: { edit: true, data: dataa[0] } })
    }
    const handleSingleCheckbox = (position, e) => {

        setCheckedState(prev => {
            let a = [];
            if (prev.length === 0) {
                driverList.map((item, index) => index === position ? a.push(true) : a.push(false))
            }
            else {
                prev.map((item, index) =>
                    index === position ? a.push(!item) : a.push(item)
                )
            }
            return [...a];
        });
    };
    const handleCheckbox = () => {
        setCheckedStateAll(prev => { return !prev });
    }
    const filterPlantName = getPlantValue();
    const ResetPinRender = (props) => {
        // console.log("props of resetpinrender", props.data_value.driver_id)
        var end = new Date(props.data_value.password_reset_time);
        var diff = false;
        var diffMs = (new Date() - end);
        // var diffMins = Math.abs(Math.round(((diffMs % 86400000) % 3600000) / 60000)); // minutes
        var diffMins = Math.abs(Math.round(diffMs / 60000)); // minutes
        // console.log('dddddd = ', diffMs, diffMins, props.data_value.first_name, props.data_value.password_reset_time)
        if (diffMins < 10 && diffMins >= 0) {
            diff = true;
            setTimer(prev => {
                var a = []
                prev.map((d, i) => { a.push(d) })
                if (!a.some(el => el.driver_id === props.data_value.driver_id)) {
                    a.push({
                        'driver_id': props.data_value.driver_id,
                        'diffMins': diffMins,
                        'endTime': end,
                        'id_index': props.index,
                    })
                }
                return a
            })
        }
        return (
            diff === true ?
                <div style={{ display: 'flex' }}>
                    <button className={clsx("reset_pin", 'disabled')} disabled onClick={(e) => resetPin(e, props.data_value, props.index)}>Reset Pin</button>&nbsp;&nbsp;
                    <div style={{ display: 'flex', alignItems: 'center', height: '22px' }}>
                        <svg width="18" height="18" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.48348 11.9892C5.32573 11.9892 4.21539 11.5292 3.39674 10.7106C2.57808 9.89194 2.11816 8.7816 2.11816 7.62385C2.11816 6.46609 2.57808 5.35576 3.39674 4.5371C4.21539 3.71845 5.32573 3.25853 6.48348 3.25853C7.64123 3.25853 8.75157 3.71845 9.57022 4.5371C10.3889 5.35576 10.8488 6.46609 10.8488 7.62385C10.8488 8.7816 10.3889 9.89194 9.57022 10.7106C8.75157 11.5292 7.64123 11.9892 6.48348 11.9892ZM6.48348 2.0113C4.99494 2.0113 3.56737 2.60262 2.51481 3.65517C1.46225 4.70773 0.870931 6.13531 0.870931 7.62385C0.870931 9.11239 1.46225 10.54 2.51481 11.5925C3.56737 12.6451 4.99494 13.2364 6.48348 13.2364C7.97202 13.2364 9.39959 12.6451 10.4522 11.5925C11.5047 10.54 12.096 9.11239 12.096 7.62385C12.096 6.13531 11.5047 4.70773 10.4522 3.65517C9.39959 2.60262 7.97202 2.0113 6.48348 2.0113ZM6.79529 4.50576H5.85986V8.24746L8.82204 10.0248L9.28975 9.25772L6.79529 7.77975V4.50576ZM3.91418 1.63089L3.11595 0.676758L0.247314 3.07768L1.05178 4.03181L3.91418 1.63089ZM12.7196 3.08392L9.85101 0.676758L9.04655 1.63089L11.9152 4.03805L12.7196 3.08392Z" fill="#707070" />
                        </svg>
                    </div>&nbsp;
                    <div id={`reset_pin_timer_minutes_${props.index}`} ref={timer_minutes} className='driver_resetTimer'></div>
                    &nbsp;<div className='driver_resetTimer'>:</div>&nbsp;
                    <div id={`reset_pin_timer_seconds_${props.index}`} ref={timer_seconds} className='driver_resetTimer'></div>
                </div> :
                <button className='reset_pin' onClick={(e) => resetPin(e, props.data_value)}>Reset Pin</button>
        )
    }
    const PinReset = (props) => {
        // console.log(props.pin)
        return (
            <div className="reset_pin_container">
                <div className="reset_pin_container_heading">Your New Pin</div>
                <div className="reset_pin_container_pin">{props.pin}</div>
            </div>
        )
    }
    const fetchDriverList = async () => {
        const response = await driverListApi(APILimit, 0, filterPlantName.value);
        // console.log("response = ", response.data.data)
        var ab = {}
        var data = response.data.data.map(function (obj, index) {
            return Object.assign({}, obj, {
                reset_pin: <ResetPinRender data_value={obj} index={index} />
            });
        })
        // console.log("data = ", data, ab)
        setLoader(true);
        // increaseOffset();
        // increaseRef();
        sethasNext(response?.data?.has_next);
        setSelectedRows([...selectedRows, ...new Array(response.data.data.length).fill(false)])
        setCheckedState([...selectedRows, ...new Array(response.data.data.length).fill(false)])
        if (offset !== 0) {
            let temp = [...driverList]
            data.forEach(element => {
                temp.push(element)
            });
            setDriverDataList(temp);
            setTotalData(temp.length);
        } else {
            setDriverDataList(data);
            setTotalData(data.length);
        }
    };

    const changeDateTime = (driver, time, updatedBy, updatedAt) => {
        // console.log("driver = ", driver)
        var ab = []
        driverList.map((d, i) => {
            if (d.driver_id == driver.driver_id) {
                d.reset_pin = <ResetPinRender data_value={d} index={i} />
                d.password_reset_time = String(time);
                if (updatedBy) { d.updated_by = updatedBy }
                if (updatedAt) { d.updated_at = String(updatedAt) }
                ab.push(d)
            }
            else (
                ab.push(d)
            )
        })
        // console.log("ab = ",ab);
        setDriverDataList(ab)
    }

    useEffect(() => {
        fetchDriverList()
        setPageLeaveTime(new Date())
    }, [])
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])

    useEffect(() => {
        var a = []
        timer.map((time, index) => {
            var deadline = time.endTime.getTime();
            var offset_10 = new Date(new Date() - (1000 * 60 * reset_pin_timer)).getTime();
            var delay = deadline - offset_10;
            var end_date = new Date().getTime() + delay;
            // console.log("ddd = ", end_date - new Date().getTime());
            var x = setInterval(function () {
                var t = end_date - new Date().getTime();
                if (t < 0) {
                    clearInterval(x);
                    changeDateTime(time, new Date(new Date() - (600000 * 3)))
                }
                else {
                    // var days = Math.floor(t / (1000 * 60 * 60 * 24));
                    // var hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((t % (1000 * 60)) / 1000);
                    // console.log("id = ", t, "-----", index, x, minutes, seconds)
                    document.getElementById(`reset_pin_timer_minutes_${time.id_index}`).innerHTML = String(minutes).padStart(2, '0');
                    document.getElementById(`reset_pin_timer_seconds_${time.id_index}`).innerHTML = String(seconds).padStart(2, '0');
                }
            }, 1000);
            a.push({ 'id': time.driver_id, 'timeOut': x })
        })
        return () => {
            a.map((time) => { clearInterval(time.timeOut) })
        };
    }, [timer])

    async function resetPin(e, data_value) {
        // console.log("reset pin", data_value)
        const payload = {
            driver_id: data_value?.driver_id,
            driver_mobile_no: data_value?.driver_mobile_no,
            updated_by: user?.name,
            updated_by_id: user?.userID,
        };
        // console.log("payload = ", payload)
        var response = await resetDriverPinApi(payload)
            .then((res) => {
                // console.log(res.data, res?.data?.data[0].password);
                if (res.status == 200) {
                    setTitle(<PinReset pin={res?.data?.data[0]?.password} />);
                    successToggleModal();
                    changeDateTime(data_value, new Date(), user?.name, new Date())
                    // console.log("time = ", data_value.updated_by, user?.name)
                    // data_value.updated_by = user?.name
                    // console.log("fdffdfd = ", location?.pathname)
                    setIsBulktIsDeletedFlag(false)
                    const a = path_Operation?.filter((d, i) => {
                        return d?.name == "create-driver"
                    })
                    // console.log("A = ", a[0]?.operation)
                    postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : "create-driver", new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
                }
            })
            .catch((error) => {
                // console.log(error);
                setTitle(error?.response?.data?.message);
                setErrorModalIsOpen(true);
            });
    }

    const updateSetSelectedRows = async (pos, data, ind) => {
        // console.log("pos = ", pos)
        if (pos == "all") {
            // console.log("pos in parent = ", pos, ind, data)
            setAllSelectedRows(!allSelectedRows)
            // console.log("allSelectedRows",allSelectedRows)
            var ab = driverList.map((row, index) => {
                if (ind.includes(index + 1)) {
                    return !allSelectedRows
                }
                return allSelectedRows
            })
            // console.log(" = ", ab)
            setSelectedRows(ab)
        }
        else {
            setSelectedRows(prev => {
                let a = [];
                prev.map((item, index) =>
                    index === pos ? a.push(!item) : a.push(item)
                )
                // console.log("a",a);
                return [...a];
            });
        }
    }
    useEffect(() => {
        setCheckedState(prev => {
            return [...new Array(driverList.length).fill(checkedStateAll)];
        });
    }, [checkedStateAll])
    useEffect(() => {
        setSelectCount(checkedState.filter(value => value === true).length)
    }, [checkedState])
    const successToggleModal = (e) => {
        // console.log("successToggleModal called")
        setIsSuccessModalOpen(!isSuccessModalOpen);
        // setTitle('')
        if (isBulkDeletedFlag) {
            window.location.reload();
        }
        // fetchDriverList()
    };
    const toggleModal = (e) => {
        setModalIsOpen(!isModalOpen);
        if (totalError)
            window.location.reload();
    };
    const handleMultipleDelete = async (data, e) => {
        // e.target.disabled = true;
        var deleteData = [];
        var deleteJsonpayload = {}
        data.forEach(element => {
            // console.log("zone_id", element.area_id);
            deleteData.push(element.driver_id);
        });
        deleteJsonpayload = { id: deleteData, updated_by: user.name, updated_by_id: user.userID }
        console.log("delete payload = ", deleteJsonpayload, title)
        const response = await bulkDriverDeleteAPI(deleteJsonpayload)
            .then(response => {
                setTitle("Driver deleted successfully");
                // e.target.disabled = false;
                setIsSuccessModalOpen(true);
                setIsBulktIsDeletedFlag(true)
                // console.log("fdffdfd = ", location?.pathname)
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == "delete-driver-multiple"
                })
                console.log("A = ", a[0]?.operation)
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : 'delete-driver-multiple', new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
            })
            .catch(error => {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == "delete-driver-multiple"
                })
                console.log("A = ", a[0]?.operation)
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : 'delete-driver-multiple', new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
                // console.log("error = ", error.response.data)
                var errorMessagePayload = {
                    totalData: error.response.data.total_count,
                    failedData: error.response.data.fail_to_delete_count,
                    errorMessageData: []
                };
                error.response.data.data.forEach(element => {
                    errorMessagePayload.errorMessageData.push(element);
                });
                if (errorMessagePayload.totalData == errorMessagePayload.failedData)
                    setTotalError(false);
                else
                    setTotalError(true);
                setTitle(errorMessagePayload);
                // console.log('errorMessagePayload = ',errorMessagePayload)
                setModalIsOpen(true);
            });
    }
    return (
        <>
            {loader ?
                <>
                    <div className='breadcrumb'>
                        <BackButton action={"Driver Onboarding"} handleClick={browserBack} />
                    </div>
                    <div className="headerwithcount">
                        <div className='countdiv'>
                            <CustomTab
                                isSelected={false}
                                title={"Driver Onboarding"}
                                withOutCount={true}
                            />
                        </div>
                        <div className="blankdiv" ></div>

                    </div>
                    {/* { */}
                    {/* view ? */}
                    <div className="table-container">
                        <div className="table-main" >
                            <Table
                                columns={[...driverListTableHeader]}
                                defaultColumns={[...driverListTableHeader]}
                                rowHeight={38}
                                rows={driverList}
                                primaryAction={{
                                    name: "Add New Driver",
                                    backgroundColor: '#82C1A7',
                                    actionFn: () => createDriverRedirect(),
                                    shouldEnable: filterPlantName.value === 'all' ? false : true,
                                    authOperation: AUTH_CODE?.CREATE,
                                }}
                                secondaryActions={[
                                    {
                                        name: "Delete",
                                        actionFn: (data, e) => toggleWarningModal(data, e),
                                        backgroundColor: '#F17C7C',
                                        shouldEnable: true,
                                        authOperation: AUTH_CODE?.DELETE,
                                    },
                                    {
                                        name: "Edit",
                                        actionFn: (data) => handleEdit(data),
                                        backgroundColor: '#82C1A7',
                                        shouldEnable: false,
                                        authOperation: AUTH_CODE?.EDIT,
                                    },
                                    {
                                        name: "Download CSV",
                                        actionFn: () => downloadData(selectedRows, driverList, "Driver"),
                                        backgroundColor: '#82C1A7',
                                        shouldEnable: true,
                                        authOperation: AUTH_CODE?.DOWNLOAD,
                                    }
                                ]}
                                // setAsnCount={setCount}
                                removeRowSelection={false}
                                pagination={true}
                                infiniteScroll={true}
                                actionButtons
                                hasNext={hasNext}
                                loadMoreData={() => fetchDriverList()}
                                // onClickPath="/driver-master/driver-details"
                                setTotalData={setTotalData}
                                selectedRows={selectedRows}
                                updateSetSelectedRows={updateSetSelectedRows}
                                selectCount={selectCount}
                                handleSingleCheckbox={(e) => handleSingleCheckbox(e)}
                                handleCheckbox={(e) => handleCheckbox(e)}
                            />
                        </div>
                        {isWarningModalOpen && (<WarningModal open={isWarningModalOpen} handleClose={() => toggleWarningModal()} confirmDelete={() => handleMultipleDelete(deleteData)} />)}
                        {isModalOpen && <FormModal open={isModalOpen} handleClose={() => toggleModal()} title={title} />}
                        {isSuccessModalOpen && <SuccessModal open={isSuccessModalOpen} handleClose={() => successToggleModal()} title={''} render_title={title} />}
                        {<ErrorModal open={isErrorModalOpen} handleClose={() => setErrorModalIsOpen(false)} title={title} />}
                    </div>
                    {/* : */}
                    {/* {driverList.length > 0 ?
                                <MapComponent data={driverList} hasNext={hasNext} nextFetch={fetchDriverList} selectedRows={selectedRows} authOperation={{ edit: true, delete: true, download: true, create: true }} />
                                : <div style={{ marginTop: "1rem" }}><DataNotFound /></div>}  */}

                    {/* <img className='dashboard-floating-allVINs' src={hamburger} alt="hamburger" onClick={() => setView(!view)} /> */}
                    <style jsx="true">
                        {`
                         a {
                            text-decoration: none;
                            color: inherit;
                          }
                .horizontal-line{
                    margin: 1rem 0 0;
                }
                .toggle-main {
                    display: flex;
                    gap: 0.5rem;
                    align-items: center;
                    padding-left: 10px;
                }
                .toggle-text{
                    font-family: Open Sans;               
                    font-weight: 700;
                    line-height: 22px;
                    letter-spacing: 0em;
                    text-align: center;
                    color: #4e4e4e;
                }
                .toggle-text.right{
                    margin-left:0.25rem;
                }
                .switch input {
                    position: absolute;
                    opacity: 0;
                  }
                  .switch {
                    display: flex;
                    align-items: center;
                    height: 8px;
                    width: 30px;
                    background: transparent;
                    border-radius: 1em;
                    border: 2px solid #2E75B5;
                    cursor: pointer;
                  }
                  .switch div {
                    height: 20px;
                    width: 20px;
                    border-radius: 50%;
                    background: #2E75B5;
                    box-shadow: 0 0.1em 0.3em rgba(0,0,0,0.3);
                    -webkit-transform: translate3d(-5px, 0, 0);
                       -moz-transform: translate3d(-5px, 0, 0);
                            transform: translate3d(-5px, 0, 0);
                    -webkit-transition: all 300ms;
                       -moz-transition: all 300ms;
                            transition: all 300ms;
                  }
                  .switch input:checked + div {
                    -webkit-transform: translate3d(calc(100% - 5px), 0, 0);
                       -moz-transform: translate3d(calc(100% - 5px), 0, 0);
                            transform: translate3d(calc(100% - 5px), 0, 0);
                  }
                .reset_pin{
                    font-weight: 600;
                    font-size: var(--mediumFontSize);
                    line-height: var(--mediumFontSize);
                    display: flex;
                    align-items: center;
                    text-decoration-line: underline;
                    background: transparent;
                    color: #82C1A7;
                    border: none;
                    cursor: pointer;
                    padding: 0;
                }
                .reset_pin_container{
                    display: flex;
                    flex-direction: column;
                }
                .disabled{
                    color: #B3B3B3;
                    cursor: unset;
                    text-decoration-line: none;
                    display: flex;
                    align-items: center;
                }
                .reset_pin_container_heading{
                    font-weight: 400;
                    font-size: var(--mediumFontSize);
                    line-height: 22px;
                    align-items: center;
                    color: #707070;
                    display: flex;
                    justify-content: center;
                    padding-bottom: 0.5rem
                }
                .reset_pin_container_pin{
                    font-weight: 600;
                    font-size: var(--xxlargeFontSize);
                    letter-spacing: 1rem;
                    line-height: 44px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    text-transform: uppercase;
                    color: #707070;
                }
                .driver_resetTimer{
                    font-size: var(--mediumFontSize);
                    line-height: 22px;
                }
                @media only screen and (max-width: 1440px) {
                    .horizontal-line{
                        margin: 0.5rem 0 0;
                    }
                }
                @media only screen and (max-width: 768px) {
                    .table-container-footer, .dashboard-footer {
                        bottom: 3rem;
                    }
                    .dispatch-map-inner{
                        flex-direction: column;
                    }
                    .dispatch-map{
                        width: 100%;
                        height: 40rem;
                    }
                    .dispatch-footer{
                        flex-direction: column;
                        gap: 1rem;
                    }
                    .dispatch-table-container{
                        display: none;
                    }
                    .toggle-main {
                        display: none;
                    }
                }
                /* Dont move it to any css file, keep it here only */
                @media only screen and (max-width: 768px) {
                    .mob-secondary-navbar{
                        width: calc(100% - 2rem);
                        position: fixed;
                        left: 0;
                        top: 0;
                    }
                    .mob-secondary-header{
                        display: flex;
                        // background: #F3F5F9;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.25rem 1rem;
                        font-weight: 600;                        
                        line-height: 19px;
                        color: #707070;
                        width: 100%;
                    } 
                    .mob-header-heading{
                        display: flex;
                        align-items: center;
                        white-space: nowrap;
                    }
                    .mob-header-heading img{
                        height: 20px;
                        margin-right: 0.5rem;
                    }
                    .mobile-card-container{
                        margin-top: 1rem;
                    }
                   
                }
                `}
                    </style>
                </>
                : <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Loader />
                </div>}
        </>
    );

}
export default DriverMaster